import { render } from "./newPage.vue?vue&type=template&id=3dc9097d&scoped=true"
import script from "./newPage.vue?vue&type=script&lang=js"
export * from "./newPage.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-3dc9097d"

export default script